export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026年8月每日大赛月度冠军揭晓：知识王者诞生',
    excerpt: '经过30天的激烈角逐，来自广东的李明以累计9850积分荣登8月知识竞赛月度冠军宝座，获得价值5000元的奖品大礼包。',
    content: `<p>经过30天的激烈角逐，来自广东的李明以累计9850积分荣登8月知识竞赛月度冠军宝座。这位28岁的中学历史老师表示，参与每日大赛已经成为他每天必不可少的习惯。</p>
    <p>"每天花半小时答题，既巩固了专业知识，又能和其他爱好者切磋，还能赢奖品，简直一举三得。"李明在赛后采访中这样说道。</p>
    <h3>月度排行榜前十名</h3>
    <p>本月知识竞赛排行榜前十名选手来自全国不同省市，展现了每日大赛在全国范围内的广泛影响力。第二名来自四川的王芳获得9200分，第三名来自上海的陈伟获得8950分。</p>
    <h3>丰厚奖品</h3>
    <p>月度冠军李明获得的奖品大礼包包含：最新款平板电脑一台、每日大赛定制纪念奖杯、全年VIP会员资格以及500元现金奖励。所有进入前十名的选手也都获得了不同等级的奖励。</p>
    <h3>下月预告</h3>
    <p>9月知识竞赛将推出全新题库，新增"科技前沿"和"传统文化"两个专题板块，题量提升至每日50题，积分获取机制也将更加灵活。敬请期待！</p>`,
    category: 'zhishi-jingsai',
    categoryName: '知识竞赛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20golden%20trophy%20on%20a%20podium%20with%20warm%20stage%20lighting%2C%20championship%20celebration%20scene%20with%20confetti%2C%20clean%20minimal%20background%2C%20editorial%20photography%20style%20with%20soft%20shadows%2C%20warm%20amber%20tones%2C%20achievement%20and%20victory%20atmosphere&width=800&height=500&seq=article-1-cover&orientation=landscape',
    author: '赛事编辑部',
    publishDate: '2026-08-10',
    readTime: 8,
    tags: ['月度冠军', '知识竞赛', '排行榜', '赛事回顾'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '每日大赛脑力竞技新赛制上线：记忆宫殿挑战赛',
    excerpt: '全新的"记忆宫殿挑战赛"正式上线！通过虚拟现实技术打造的3D记忆场景，让你在沉浸式体验中挑战记忆力极限。',
    content: `<p>每日大赛脑力竞技板块迎来重大更新！全新的"记忆宫殿挑战赛"正式上线，采用前沿的虚拟现实技术，为参赛者打造沉浸式的3D记忆场景。</p>
    <h3>什么是记忆宫殿挑战赛？</h3>
    <p>记忆宫殿是一种古老的记忆术，通过在脑海中构建一个熟悉的空间（如自己的家），将需要记忆的信息放置在该空间的不同位置，从而达到高效记忆的效果。</p>
    <p>每日大赛将这一经典方法进行了数字化升级，参赛者将在虚拟3D场景中记忆物品位置、数字序列、人名面孔等信息，每天挑战不同难度等级。</p>
    <h3>赛制说明</h3>
    <p>挑战赛分为三个难度等级：初级（记忆10个物品）、中级（记忆20个物品+关联信息）、高级（记忆30个物品+复杂关联+限时）。参赛者每天可选择任意难度参赛，积分根据难度系数加权计算。</p>
    <h3>参与方式</h3>
    <p>无需下载额外软件，通过每日大赛平台即可直接参与。首次参与将获得新手引导教程，帮助快速上手。每日最佳成绩将计入总排行榜。</p>`,
    category: 'naoli-jingji',
    categoryName: '脑力竞技',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20digital%20brain%20visualization%20with%20glowing%20neural%20connections%2C%20holographic%203D%20memory%20palace%20concept%2C%20clean%20dark%20background%20with%20subtle%20light%20particles%2C%20modern%20tech%20aesthetic%2C%20warm%20accent%20lighting&width=800&height=500&seq=article-2-cover&orientation=landscape',
    author: '技术团队',
    publishDate: '2026-08-08',
    readTime: 6,
    tags: ['新赛制', '脑力竞技', '记忆宫殿', 'VR技术'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '创意大赛本周主题揭晓："城市印象"摄影挑战',
    excerpt: '本周创意大赛主题定为"城市印象"，参赛者需用镜头捕捉自己所在城市的独特风貌与人文气息，优秀作品将获得专业摄影师的点评指导。',
    content: `<p>本周创意大赛主题正式揭晓——"城市印象"摄影挑战。从8月12日至8月18日，参赛者需用镜头捕捉所在城市最具代表性的风貌与人文气息。</p>
    <h3>参赛要求</h3>
    <p>每位参赛者每天可提交1-3张作品，要求原创拍摄，不得使用AI生成图片。作品需体现城市特色，可以是建筑、街景、人文、生活场景等。</p>
    <h3>评选标准</h3>
    <p>作品将从构图（30%）、创意（25%）、主题契合度（25%）、技术质量（20%）四个维度进行评分。由专业摄影师团队和大众投票共同决定最终排名。</p>
    <h3>奖项设置</h3>
    <p>每日前三名获得积分奖励，周冠军将获得专业相机配件礼包及作品展示机会。所有参赛作品将在每日大赛创意长廊中永久展示。</p>`,
    category: 'chuangyi-dasai',
    categoryName: '创意大赛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20city%20skyline%20reflected%20in%20a%20camera%20lens%2C%20artistic%20urban%20photography%20concept%2C%20warm%20golden%20hour%20lighting%2C%20clean%20composition%20with%20soft%20bokeh%20background%2C%20creative%20photography%20aesthetic&width=800&height=500&seq=article-3-cover&orientation=landscape',
    author: '创意编辑部',
    publishDate: '2026-08-07',
    readTime: 5,
    tags: ['创意大赛', '摄影挑战', '城市印象', '每周主题'],
    featured: false,
  },
  {
    id: 'article-4',
    title: '运动挑战暑期特辑：30天健身蜕变计划启动',
    excerpt: '暑假来临，每日大赛运动挑战板块推出"30天健身蜕变计划"，每天一个科学健身任务，助你在这个夏天遇见更好的自己。',
    content: `<p>随着暑期的到来，每日大赛运动挑战板块特别推出"30天健身蜕变计划"。从基础拉伸到进阶力量训练，每天一个经过专业教练设计的健身任务，帮助参赛者在30天内完成一次身体的蜕变。</p>
    <h3>计划亮点</h3>
    <p>本计划由国家级健身教练团队精心设计，结合了HIIT、瑜伽、力量训练和功能性训练等多种方式。每天只需20-30分钟，无需专业器械，在家即可完成。</p>
    <h3>打卡与积分</h3>
    <p>每天完成训练并打卡即可获得运动积分，连续打卡7天、14天、30天分别获得额外奖励积分。积分可用于兑换运动装备、健身课程等实用奖品。</p>
    <h3>社群互动</h3>
    <p>参与者可在运动挑战社群中分享训练心得、饮食建议和蜕变对比照，互相激励，共同进步。每周还将评选"最佳蜕变奖"。</p>`,
    category: 'yundong-tiaozhan',
    categoryName: '运动挑战',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20doing%20morning%20yoga%20in%20a%20bright%20minimal%20living%20room%20with%20large%20windows%20and%20natural%20sunlight%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20fitness%20and%20wellness%20lifestyle%20photography&width=800&height=500&seq=article-4-cover&orientation=landscape',
    author: '运动编辑部',
    publishDate: '2026-08-05',
    readTime: 7,
    tags: ['运动挑战', '健身计划', '暑期特辑', '健康生活'],
    featured: true,
  },
  {
    id: 'article-5',
    title: '游戏竞技《脑力激荡》季赛即将开启，总奖池超10万元',
    excerpt: '每日大赛游戏竞技板块年度重头戏——《脑力激荡》季赛将于9月1日正式开启，总奖池超过10万元，诚邀全国玩家参与角逐。',
    content: `<p>每日大赛游戏竞技板块年度重头戏——《脑力激荡》季赛将于9月1日正式开启报名。本届季赛总奖池超过10万元，是历届之最。</p>
    <h3>赛事规模</h3>
    <p>《脑力激荡》是一款融合了数独、逻辑谜题、文字游戏等多种玩法的综合脑力游戏。季赛为期三个月，分为预选赛、晋级赛和总决赛三个阶段，预计将吸引超过5万名参赛者。</p>
    <h3>奖金分配</h3>
    <p>总冠军独享3万元现金奖励及定制奖杯，亚军1.5万元，季军8000元。进入前100名的选手均可获得不同金额的现金奖励或实物奖品。</p>
    <h3>报名条件</h3>
    <p>凡每日大赛注册用户均可免费报名参加。预选赛阶段不限制参赛次数，取最佳成绩进入晋级赛。报名通道将于9月1日上午10:00正式开放。</p>`,
    category: 'youxi-jingji',
    categoryName: '游戏竞技',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20competitive%20gaming%20arena%20with%20glowing%20screens%20and%20holographic%20scoreboards%2C%20esports%20tournament%20atmosphere%2C%20warm%20ambient%20lighting%2C%20clean%20futuristic%20design%2C%20grand%20stage%20with%20spotlights&width=800&height=500&seq=article-5-cover&orientation=landscape',
    author: '游戏编辑部',
    publishDate: '2026-08-03',
    readTime: 6,
    tags: ['游戏竞技', '季赛', '高额奖金', '脑力激荡'],
    featured: true,
  },
  {
    id: 'article-6',
    title: '音乐比赛本月之星：草根歌手张小花的故事',
    excerpt: '从街边卖唱到每日大赛音乐比赛的月度冠军，草根歌手张小花用实力证明了梦想的力量。今天我们来听听她的故事。',
    content: `<p>张小花，一个来自云南小城的25岁女孩，曾经每天晚上在昆明街头唱歌谋生。今年3月，她偶然发现了每日大赛的音乐比赛板块，抱着试试看的心态上传了自己的第一首翻唱作品。</p>
    <h3>从零到冠军</h3>
    <p>第一周只获得了23票，但张小花没有放弃。她认真阅读每一位听众的评论，不断改进演唱技巧。两个月后，她的原创歌曲《山间的风》在每日音乐比赛中获得了单日最高票数。</p>
    <h3>梦想照进现实</h3>
    <p>7月，张小花以累计得分第一的成绩获得音乐比赛月度冠军。她的原创作品被多家音乐平台收录，粉丝数从零增长到超过5万。"每日大赛给了普通人一个展示才华的舞台，让我相信只要坚持，梦想终会实现。"</p>`,
    category: 'yinyue-bisai',
    categoryName: '音乐比赛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20female%20singer%20with%20acoustic%20guitar%20on%20a%20warm%20lit%20stage%2C%20intimate%20music%20performance%20scene%2C%20soft%20spotlight%2C%20emotional%20atmosphere%2C%20clean%20minimal%20background%2C%20warm%20golden%20tones&width=800&height=500&seq=article-6-cover&orientation=landscape',
    author: '人物编辑部',
    publishDate: '2026-08-01',
    readTime: 9,
    tags: ['音乐比赛', '草根歌手', '人物故事', '月度之星'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '每日大赛积分系统全面升级：更多玩法更多奖励',
    excerpt: '为了更好地回馈广大参赛者，每日大赛积分系统进行了全面升级。新增任务积分、连续签到奖励、社交分享积分等多种获取方式。',
    content: `<p>为了更好地回馈广大参赛者，每日大赛积分系统于8月初完成了全面升级。新系统增加了多种积分获取方式，让每一位参赛者都能找到适合自己的积分增长路径。</p>
    <h3>新增积分获取方式</h3>
    <p>除了原有的赛事参赛积分外，新增了每日签到积分（连续签到天数越多积分越高）、任务积分（完成指定任务可获得额外积分）、社交分享积分（邀请好友参赛双方均可获得积分）。</p>
    <h3>积分兑换升级</h3>
    <p>积分商城同步升级，新增电子产品、图书礼券、线下赛事门票、定制周边等丰富兑换选项。积分有效期为获得后12个月，请及时使用。</p>
    <h3>VIP权益</h3>
    <p>累计积分达到一定门槛可解锁VIP等级，享受双倍积分日、专属赛事、优先兑换等特权。详细等级规则请查看个人中心。</p>`,
    category: 'zhishi-jingsai',
    categoryName: '知识竞赛',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20dashboard%20showing%20points%20and%20rewards%20system%2C%20clean%20UI%20design%20concept%2C%20warm%20gradient%20background%2C%20minimal%20interface%20with%20charts%20and%20icons%2C%20professional%20tech%20aesthetic&width=800&height=500&seq=article-7-cover&orientation=landscape',
    author: '产品团队',
    publishDate: '2026-07-28',
    readTime: 5,
    tags: ['积分系统', '产品更新', '奖励机制', 'VIP'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '每日大赛x知名高校合作：校园大使招募计划启动',
    excerpt: '每日大赛与全国20所知名高校达成合作，正式启动校园大使招募计划。成为校园大使，代表你的学校参与全国高校竞技联赛。',
    content: `<p>每日大赛正式宣布与全国20所知名高校达成战略合作，同步启动校园大使招募计划。这一举措旨在将每日大赛的竞技精神带入校园，丰富大学生的课余生活。</p>
    <h3>校园大使职责</h3>
    <p>校园大使将作为每日大赛在各自高校的代表，负责组织校园赛事活动、推广每日大赛平台、组建校园战队参与全国高校联赛。任期一年，表现优异者可获得实习证明和推荐信。</p>
    <h3>福利待遇</h3>
    <p>校园大使享受VIP会员权益、专属培训资源、赛事优先参与权以及每月津贴。年度优秀校园大使还将获得海外交流机会和5000元奖学金。</p>
    <h3>如何申请</h3>
    <p>在校大学生可通过每日大赛官网校园大使专区提交申请，需提供个人简历、校园活动经历和自我推荐信。首批招募截止日期为9月15日。</p>`,
    category: 'naoli-jingji',
    categoryName: '脑力竞技',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20university%20campus%20with%20students%20collaborating%20on%20a%20project%2C%20modern%20architecture%2C%20bright%20natural%20light%2C%20academic%20atmosphere%2C%20clean%20composition%2C%20warm%20and%20inviting%20tones&width=800&height=500&seq=article-8-cover&orientation=landscape',
    author: '合作发展部',
    publishDate: '2026-07-25',
    readTime: 7,
    tags: ['高校合作', '校园大使', '招募计划', '高校联赛'],
    featured: false,
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id) || null;
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (currentId: string, category: string, limit: number = 3) => {
  return articles
    .filter((a) => a.category === category && a.id !== currentId)
    .slice(0, limit);
};